import styled from 'styled-components';

export const FieldMessages = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  padding-bottom: 4px;
`;

export default FieldMessages;
